import { render, staticRenderFns } from "./TipsForm.vue?vue&type=template&id=4f6c850b"
import script from "./TipsForm.vue?vue&type=script&lang=ts"
export * from "./TipsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports